module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/6_aba14b8949e05c9d9ccf7d0787e5f3f3.jpg";